module.exports = __webpack_public_path__ + "img/auth.3f9693cf.png";